import React from 'react';
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(NavLink)`
    color: #135CA9;
    cursor: pointer;
    text-decoration: none;
    font-weight: 500;

    &:hover {
        text-decoration: underline;
    }
    
    &.disabled {
        color: #999;
        cursor: not-allowed;
        pointer-events: none;
    }
`;

const FileNameLink = ({fileName, status, onClick, fileLink}) => {
    // Если onClick передан и статус позволяет, используем NavLink для поддержки открытия в новой вкладке
    if (onClick && fileLink && (status === 'Completed' || status === 'ParcelsCreated')) {
        return (
            <StyledLink 
                to={fileLink}
                onClick={(e) => {
                    // Если нажаты модификаторы или средняя кнопка мыши, 
                    // позволяем браузеру обработать клик самому (открыть в новой вкладке)
                    if (e.ctrlKey || e.metaKey || e.button === 1) {
                        return;
                    }
                    // Для обычного клика предотвращаем стандартное поведение и вызываем onClick
                    e.preventDefault();
                    onClick();
                }}
            >
                {fileName}
            </StyledLink>
        );
    }

    return (
        <span className="disabled" style={{color: '#999', cursor: 'not-allowed'}}>
            {fileName}
        </span>
    );
};

export default FileNameLink;



// WEBPACK FOOTER //
// ./App/pages/massUpload/components/FileNameLink.jsx